import { addDaysToIsoDate } from '@/utils/isoDateMath'

export type LaborRangePreset = 'last13weeks' | 'ytd' | 'ltm' | 'custom'

export function todayIsoDate(reference = new Date()): string {
  const year = reference.getFullYear()
  const month = String(reference.getMonth() + 1).padStart(2, '0')
  const day = String(reference.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function laborRangeForPreset(
  preset: Exclude<LaborRangePreset, 'custom'>,
  referenceDate = todayIsoDate(),
): { start: string; end: string } {
  const end = referenceDate
  if (preset === 'last13weeks') {
    return { start: addDaysToIsoDate(end, -(13 * 7 - 1)), end }
  }
  if (preset === 'ytd') {
    const year = end.slice(0, 4)
    return { start: `${year}-01-01`, end }
  }
  return { start: addDaysToIsoDate(end, -364), end }
}

export function laborQueryButtonLabel(refreshing: boolean): string {
  return refreshing ? 'Running…' : 'Run query'
}

export function laborQueryShowsCacheMenu(hasCachedValues: boolean): boolean {
  return hasCachedValues
}
